import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from '../StyledModal';

import EnterSend from "../EnterSend";

import { NotificationManager } from 'react-notifications';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';

function MyModalDeleteEvaluationEleve(props) {
  const dispatch = useDispatch();
  const evaluations = useSelector(state => state.noteDetail.arr);

  function onModalClose(event) {
    props.onCloseModal(event, 2);
  }

  const [prenom, setPrenom] = React.useState();
  const [nom, setNom] = React.useState();
  const [note, setNote] = React.useState();

  const handleSubmit = () => {
    if(props.IsModalOpened === true) {
      deleteEvaluation()
    }
  };

  React.useEffect(() => {
    setPrenom(props.infoNote.prenom)
    setNom(props.infoNote.nom)
    setNote(props.infoNote.note)
  }, [props.infoNote]);

  function deleteEvaluation() {
    const params = {
      id_classe: props.infoNote.id_classe,
      id_seance: props.infoNote.id_seance,
      id_eleve: props.infoNote.id_eleve
    };
    
    axios.delete('https://eps.acces-editions.com/api/deleteNoteEleve', { params })
    .then(() => {
      const remainingEvaluations = evaluations.filter((evaluation) => (
        String(evaluation.id_eleve) !== String(props.infoNote.id_eleve)
        || String(evaluation.id_seance) !== String(props.infoNote.id_seance)
      ));
      dispatch({ type: 'note/noteDetail', payload: remainingEvaluations });
      dispatch({ type: 'note/eleveNbNoteDetail', payload: remainingEvaluations.length });
      NotificationManager.success('Évaluation supprimée', '', 3000);
      onModalClose(false);
    })
    .catch(() => NotificationManager.error("L'évaluation n'a pas pu être supprimée", '', 3000))
  }

  return (
    <>
      <Modal size="sm" active={props.IsModalOpened} toggler={() => {return}}>
        <ModalHeader toggler={() => onModalClose(false)}>
            Supprimer l'évaluation
        </ModalHeader>
        <ModalBody>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Prénom
            </label>
            <span>{prenom}</span>
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Nom
            </label>
            <span>{nom}</span>
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Note
            </label>
            <span>{note}</span>
            </div>
        </ModalBody>
        <ModalFooter>
            <Button 
                color="red"
                buttonType="link"
                onClick={(e) => onModalClose(false)}
                ripple="dark"
            >
                Fermer
            </Button>

            <Button
                color="green"
                onClick={(e) => deleteEvaluation()}
                ripple="light"
            >
              <EnterSend handleSubmit={handleSubmit}/>
              Supprimer
            </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default MyModalDeleteEvaluationEleve;
